<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-text-field v-model="queryForm.vehicle_number" outlined dense label="车牌号" clearable hide-details
          @keyup.enter="getdata()"></v-text-field>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <v-select outlined dense v-model="queryForm.own_type" label="车辆类型" :items="own_types" clearable hide-details
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无"></v-select>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="6">
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" dark tile @click="getdata('download')">
            <v-icon small>mdi-download</v-icon> {{ queryForm.tab === 1 ? '下载能耗数据' : '下载补能数据' }}
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.tab" size="small" @change="onTabChange">
      <a-tab-pane :key="1" tab="能耗管理"></a-tab-pane>
      <a-tab-pane :key="2" tab="补能统计"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="summaryList" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <!-- 车牌号（两个 tab 共用，合计行显示“合计”） -->
        <template slot="vehicle_number" slot-scope="text, record">
          <span :class="{
            'font-weight-bold primary--text': record._isSummary,
          }" :style="{
            'color': record.own_type_name ? $utils.textToBgColor(record.own_type_name) : ''
          }">{{ text }}</span>
        </template>
        <!-- 总越次 / 补能次数（两个 tab 共用，参与合计） -->
        <template slot="count" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ text }}</span>
        </template>
        <!-- 能耗管理：线路（合计行不显示） -->
        <template slot="postline" slot-scope="text, record">
          <span v-if="!record._isSummary">{{ text }}</span>
        </template>
        <!-- 能耗管理：总里程数(KM)（参与合计） -->
        <template slot="mileage" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ text }}</span>
        </template>
        <!-- 能耗管理：总能耗（参与合计） -->
        <template slot="used" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ text }}</span>
        </template>
        <!-- 能耗管理：平均能耗（合计行 = 总能耗 / 总里程数） -->
        <template slot="avg" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ text }}</span>
        </template>
        <!-- 补能统计：补能地点（合计行不显示） -->
        <template slot="location" slot-scope="text, record">
          <span v-if="!record._isSummary">{{ text }}</span>
        </template>
        <!-- 补能统计：补能(电量/油量)（参与合计） -->
        <template slot="qty" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ text }}</span>
        </template>
        <!-- 补能统计：金额（参与合计） -->
        <template slot="amount" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ text }}</span>
        </template>
        <!-- 补能统计：单价（合计行 = 金额 / 补能(电量/油量)） -->
        <template slot="price" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">{{ text }}</span>
        </template>
      </a-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "EnergyConsumption",
  data() {
    return {
      start_day_menu: false,
      end_day_menu: false,
      queryForm: {
        tab: 1,
        start_day: "",
        end_day: "",
        vehicle_number: "",
        own_type: null,
      },
      own_types: [
        { text: "自有车", value: 1 },
        { text: "包车", value: 3 },
      ],
      // 能耗管理表头
      headers1: [
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 140, align: "center" },
        { title: "趟次", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 100, align: "center" },
        { title: "线路", dataIndex: "postline", scopedSlots: { customRender: "postline" }, width: 200, align: "center" },
        { title: "总里程数(KM)", dataIndex: "mileage", scopedSlots: { customRender: "mileage" }, width: 140, align: "center" },
        { title: "总能耗", dataIndex: "used", scopedSlots: { customRender: "used" }, width: 200, align: "center" },
        { title: "平均能耗", dataIndex: "avg", scopedSlots: { customRender: "avg" }, width: 180, align: "center" },
      ],
      // 补能统计表头
      headers2: [
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 140, align: "center" },
        { title: "补能地点", dataIndex: "location", scopedSlots: { customRender: "location" }, width: 200, align: "center" },
        { title: "补能次数", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 170, align: "center" },
        { title: "补能(电量/油量)", dataIndex: "qty", scopedSlots: { customRender: "qty" }, width: 160, align: "center" },
        { title: "金额", dataIndex: "amount", scopedSlots: { customRender: "amount" }, width: 130, align: "center" },
        { title: "单价", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 120, align: "center" },
      ],
      list: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    headers() {
      return this.queryForm.tab === 1 ? this.headers1 : this.headers2;
    },
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    summaryList() {
      const base = { _id: "summary", _isSummary: true, vehicle_number: "合计" };
      const list = this.list || [];
      if (list.length === 0) return [];
      const toNum = (v) => {
        if (v == null || v === "") return 0;
        // 支持 "12029.326(kWh)" / "12029.326升" 这种带单位字符串
        const m = String(v).match(/-?\d+(\.\d+)?/);
        return m ? parseFloat(m[0]) || 0 : Number(v) || 0;
      };
      const count = list.reduce((s, r) => s + toNum(r.count), 0);
      // 能耗管理 tab=1：合计 总越次 / 总里程数 / 总能耗，平均能耗 = 总能耗 / 总里程数
      if (this.queryForm.tab === 1) {
        const mileage = +list.reduce((s, r) => s + toNum(r.mileage), 0).toFixed(2);
        const used = +list.reduce((s, r) => s + toNum(r.used), 0).toFixed(2);
        const avg = mileage > 0 ? +(used / mileage).toFixed(2) : 0;
        return [
          {
            ...base,
            count,
            mileage,
            used,
            avg,
          },
          ...list,
        ];
      }
      // 补能统计 tab=2：合计 补能次数 / 补能(电量/油量) / 金额，单价 = 金额 / 补能(电量/油量)
      const qty = +list.reduce((s, r) => s + toNum(r.qty), 0).toFixed(2);
      const amount = +list.reduce((s, r) => s + toNum(r.amount), 0).toFixed(2);
      const price = qty > 0 ? +(amount / qty).toFixed(2) : 0;
      return [
        {
          ...base,
          count,
          qty,
          amount,
          price,
        },
        ...list,
      ];
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.list = [];
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      tab: 1,
      start_day,
      end_day,
      vehicle_number: "",
      own_type: null,
    };
    this.getdata();
  },
  methods: {
    onTabChange() {
      this.list = [];
      this.getdata();
    },
    getdata(action) {
      if (this.MOCK_MODE) {
        this.getMockData();
        return;
      }
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/energyconsumption/list", {
        ...this.queryForm,
        action,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === 'download') {
            return this.$download(res.data.url, res.data.name);;
          }
          this.list = res.data.list;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
